import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  Button,
  Divider,
  Link,
} from '@mui/material';
import { GROUP_NAME } from '../App';

const teamMembers = [
  {
    name: 'John Smith',
    role: 'Executive Director',
    bio: 'A lifelong Colorado resident passionate about state sovereignty and constitutional rights.',
    avatar: '/api/placeholder/150/150'
  },
  {
    name: 'Sarah Johnson',
    role: 'Policy Coordinator',
    bio: 'Experienced in legislative analysis and advocacy for state-level governance.',
    avatar: '/api/placeholder/150/150'
  },
  {
    name: 'Mike Davis',
    role: 'Community Outreach',
    bio: 'Building grassroots support across Colorado for federal oversight reduction.',
    avatar: '/api/placeholder/150/150'
  }
];

export default function About() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      {/* Mission Section */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          About {GROUP_NAME}
        </Typography>
        <Typography variant="h6" color="text.secondary" paragraph>
          Advocating for Colorado's sovereignty and reducing federal overreach in the Centennial State.
        </Typography>
      </Box>

      {/* Mission Statement */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" gutterBottom>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          The {GROUP_NAME} is dedicated to promoting Colorado's constitutional rights under the 10th Amendment 
          and advocating for policies that reduce federal government overreach in our state. We believe that 
          Coloradans are best equipped to govern themselves and make decisions about their communities, 
          policing, public lands, public institutions, and private businesses.
        </Typography>
        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          Through education, advocacy, and grassroots organizing, we work to ensure that Colorado maintains 
          its sovereignty and independence while respecting constitutional principles and the rule of law.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
          We are committed to fostering a more just and equitable society in Colorado, free from unnecessary 
          federal interference that undermines our local governance and community values. This includes unconstitutional
          immigration policy that unfairly targets local communities and often violates the civil rights of our residents. 
          This also includes resisting federal pressure to end DEI policies, pressure that seeks to undermine the progress we have made in promoting access to the American Dream for all Coloradans.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
            We seek to harness the grassroots energy of recent protests to turn it into&nbsp;
            <Button
              variant="text"
              color="primary"
              component={Link}
              href="/legislation"
              sx={{ textTransform: 'none', fontWeight: 'bold', px: 0, minWidth: 0 }}
            >
              legislative action.&nbsp;
            </Button>
            
            As a matter of great urgency, this action is to be taken within our state government, by the governor's office and the legislature; where appropriate, local governments must also be engaged.
        </Typography>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Values Section */}
      <Box sx={{ mb: 8 }}>
        <Typography variant="h4" gutterBottom>
          Our Values
        </Typography>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Constitutional Principles
                </Typography>
                <Typography variant="body2">
                  We believe in the fundamental principles of the Constitution, including the 10th Amendment 
                  which reserves powers not delegated to the federal government to the states and the people.
                </Typography>
              </CardContent>
            </Card>
          </Grid>

          <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Social Justice
                </Typography>
                <Typography variant="body2">
                  We support policies that promote Colorado's independence and freedom to marshal in a more just society. 
                  We reject federal notions that undermine local protections for civil rights and social equity.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
            <Card sx={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" gutterBottom color="primary">
                  Local Governance
                </Typography>
                <Typography variant="body2">
                  Colorado communities know what's best for their residents. We advocate for policies that 
                  empower local decision-making and reduce federal interference in state affairs.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ mb: 6 }} />

      {/* Team Section */}
      {/* <Box sx={{ mb: 8 }}>
        <Typography variant="h4" gutterBottom>
          Our Team
        </Typography>
        <Grid container spacing={4}>
          {teamMembers.map((member, index) => (
            <Grid size={{ xs: 12, md: 4 }} key={index}>
              <Card sx={{ textAlign: 'center', height: '100%' }}>
                <CardContent>
                  <Avatar
                    sx={{ width: 120, height: 120, mx: 'auto', mb: 2 }}
                    alt={member.name}
                    src={member.avatar}
                  />
                  <Typography variant="h6" gutterBottom>
                    {member.name}
                  </Typography>
                  <Typography variant="subtitle1" color="primary" gutterBottom>
                    {member.role}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {member.bio}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box> */}

      {/* Call to Action */}
      <Box sx={{ textAlign: 'center', py: 6, bgcolor: 'background.paper', borderRadius: 2 }}>
        <Typography variant="h5" gutterBottom>
          Join Our Movement
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Help us protect the freedom of all Colorado residents.
        </Typography>
        {/* <Button variant="contained" color="primary" size="large" sx={{ mr: 2 }}>
          Get Involved
        </Button> */}
        <Button 
          variant="contained" 
          color="primary" 
          size="large" 
          onClick={() => navigate('/contact')}
        >
          Contact Us
        </Button>
      </Box>
    </Container>
  );
}
